module.exports = __webpack_public_path__ + "images/487224fd12f8cf9a42c2efddac38ad24-illu_dir_sign2.png";